import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV_LINKS = [
  { to: "/", label: "Home", testid: "nav-home" },
  { to: "/about", label: "About", testid: "nav-about" },
  { to: "/products/livecuts", label: "LiveCuts", testid: "nav-freshcut" },
  { to: "/products/flockfolio", label: "Flockfolio", testid: "nav-flockfolio" },
  { to: "/careers", label: "Careers", testid: "nav-careers" },
];

export default function Navigation() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      data-testid="main-navigation"
      className={`sticky top-0 z-50 backdrop-blur-xl transition-all duration-300 ${
        scrolled
          ? "bg-bone/85 border-b border-bone-300/70"
          : "bg-bone/60 border-b border-transparent"
      }`}
    >
      <div className="container-x flex items-center justify-between h-16 sm:h-20">
        <Link
          to="/"
          className="flex items-center gap-3 group"
          data-testid="brand-link"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_thiruhana-web/artifacts/8bk7o8ry_WhatsApp%20Image%202026-07-02%20at%209.59.05%20PM.jpeg"
            alt="Thiruhanarayano Innovations LLP"
            className="h-11 sm:h-12 w-auto object-contain"
            data-testid="brand-logo"
          />
          <div className="leading-tight hidden sm:block">
            <div className="font-display font-bold text-[13px] tracking-tight text-navy">
              Thiruhanarayano
            </div>
            <div className="mono-label text-gold-deep text-[10px]">
              Innovations · LLP
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              data-testid={link.testid}
              end={link.to === "/"}
              className={({ isActive }) =>
                `font-sans text-sm tracking-tight transition-colors ${
                  isActive
                    ? "text-ink-olive"
                    : "text-ink-soft hover:text-ink-olive"
                }`
              }
            >
              {link.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block">
          <Link
            to="/contact"
            data-testid="nav-cta-contact"
            className="btn-primary text-sm"
          >
            Start a project
            <span aria-hidden>→</span>
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          className="lg:hidden inline-flex items-center justify-center w-10 h-10 border border-bone-300 text-ink-olive"
          aria-label="Toggle menu"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div
          className="lg:hidden border-t border-bone-300 bg-bone"
          data-testid="mobile-menu"
        >
          <div className="container-x py-6 flex flex-col gap-4">
            {NAV_LINKS.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                data-testid={`${link.testid}-mobile`}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `font-sans text-lg tracking-tight ${
                    isActive ? "text-ink-olive" : "text-ink-soft"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              data-testid="nav-cta-contact-mobile"
              className="btn-primary text-sm w-fit mt-2"
            >
              Start a project →
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
